import { render, staticRenderFns } from "./ZhihuClub.vue?vue&type=template&id=23235490&"
import script from "./ZhihuClub.vue?vue&type=script&lang=js&"
export * from "./ZhihuClub.vue?vue&type=script&lang=js&"
import style0 from "./ZhihuClub.vue?vue&type=style&index=0&id=23235490&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports